import { render, staticRenderFns } from "./BaseBlock.vue?vue&type=template&id=e5e20322&scoped=true"
import script from "./BaseBlock.vue?vue&type=script&lang=js"
export * from "./BaseBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseBlock.vue?vue&type=style&index=0&id=e5e20322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e20322",
  null
  
)

export default component.exports